import React, { useState } from "react";
import { Card, Typography, Tabs } from "antd";
import { DatabaseOutlined, UserOutlined, MedicineBoxOutlined, ShoppingOutlined, UnorderedListOutlined, DollarOutlined, BankOutlined, AppstoreOutlined } from "@ant-design/icons";
import "../Pages/CSS/DonnesBases.css";
import ParticipCompte from "./ParticipCompte";
import FournComptSoins from "./FournComptSoins";
import FournComptDiv from "./FournComptDiv";
import ChargesTechCompte from "./ChargesTechCompte";
import ProdTechCompte from "./ProdTechCompte";
import BanquesCompte from "./BanquesCompte";
import Autres from "./Autres";
import CompteAdht from "./CompteAdht";

const { Title } = Typography;

const IntCompte = () => {
  const [activeTabKey, setActiveTabKey] = useState("participants");

  // Onglets avec icônes
  const tabItems = [
    {
      key: "participants",
      label: "Participants",
      icon: <UserOutlined />,
      children: <ParticipCompte />,
    },
    {
      key: "fournisseurs-soins",
      label: "Fournisseurs de Soins",
      icon: <MedicineBoxOutlined />,
      children: <FournComptSoins />,
    },
    {
      key: "fournisseurs-divers",
      label: "Fournisseurs Divers",
      icon: <ShoppingOutlined />,
      children: <FournComptDiv />,
    },
    {
      key: "adherents",
      label: "Adhérents",
      icon: <UnorderedListOutlined />,
      children: <CompteAdht />,
    },
    {
      key: "charges-techniques",
      label: "Charges Techniques",
      icon: <DollarOutlined />,
      children: <ChargesTechCompte />,
    },
    {
      key: "produits-techniques",
      label: "Produits Techniques",
      icon: <DollarOutlined />,
      children: <ProdTechCompte />,
    },
    {
      key: "banques",
      label: "Banques",
      icon: <BankOutlined />,
      children: <BanquesCompte />,
    },
    {
      key: "autres",
      label: "Autres",
      icon: <AppstoreOutlined />,
      children: <Autres />,
    },
  ];

  // Obtenir le label de l'onglet actif
  const getActiveTabLabel = () => {
    const activeTab = tabItems.find(tab => tab.key === activeTabKey);
    return activeTab ? activeTab.label : '';
  };

  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "12px 24px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 12,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 20,
        }}
      >
        <DatabaseOutlined style={{ fontSize: 24, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
          }}
        >
          Interrogations Compte - {getActiveTabLabel()}
        </span>
      </div>

      <Card
        style={{
          borderRadius: 12,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          border: "1px solid #f0f0f0",
        }}
      >
        <Tabs
          activeKey={activeTabKey}
          onChange={setActiveTabKey}
          items={tabItems}
          tabBarStyle={{
            fontWeight: 600,
            fontSize: 14,
            marginBottom: 0,
          }}
          tabBarGutter={16}
          type="card"
          style={{
            marginBottom: 0,
          }}
        />
      </Card>
    </div>
  );
};

export default IntCompte;
